import { FindingDto } from './finding-dto';
import { ScanModule, ScanType, Severity } from '../enums';

export interface NessusFindingDto extends FindingDto {
  scanModule: ScanModule.Nessus;
}

export namespace NessusFindingDto {
  export function mapFromApiValue(nessusFindingDto: any): NessusFindingDto {
    return {
      ...nessusFindingDto,
      scanType: ScanType.mapFromApiValue(nessusFindingDto.scanType),
      scanModule: ScanModule.Nessus,
      severity: Severity.mapFromApiValue(nessusFindingDto.severity),
    };
  }
}
